;
define("global_views_currency_selector.tpl", function(){});

